import { useOnMount } from "@hooks/index";
import { isUndefined } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import actions from "@redux/loanForm/actions";

export const useSetDefaultValue = (fieldName, defaultValue = "") => {
  const dispatch = useDispatch();
  const { initialValue } = useSelector(state => state.loanForm || {});
  const value = initialValue ? initialValue[fieldName] : null;

  useOnMount(() => {
    if (isUndefined(value) || value === null) {
      dispatch(actions.setFieldInitialValue({[fieldName]: defaultValue}));
    }
  });
};

export default useSetDefaultValue;